<template>
  <div>
    <div v-for="(packing, index) in packings" :key="index">
      <h3 class="text-center">
        Упаковочный лист / Packing list {{ index + 1 }}
      </h3>
      <p class="text-center font-italic">
        номер упаковочного листа / packing list number:
        {{ packing.invoice.display_text }}
      </p>

      <div class="row">
        <div class="col-md-6">
          <div class="table">
            <table
              border="1"
              cellpadding="10"
              cellspacing="0"
              width="100%"
              style="border-style: solid"
            >
              <tr>
                <td>
                  <strong>Получатель / Receiver</strong>
                </td>
              </tr>
              <tr>
                <td>
                  {{ packing.consignor.org_name }} <br />
                  {{ packing.consignor.org_code }} <br />
                  {{ packing.consignor.company_address }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="table">
            <table
              border="1"
              cellpadding="10"
              cellspacing="0"
              width="100%"
              style="border-style: solid"
            >
              <tr>
                <td>
                  <strong>Отправитель / Sender</strong>
                </td>
              </tr>
              <tr>
                <td>
                  {{ packing.consignee.org_name }} <br />
                  {{ packing.consignee.org_code }} <br />
                  {{ packing.consignee.company_address }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table
            border="1"
            cellpadding="10"
            cellspacing="0"
            width="100%"
            style="border-style: solid"
          >
            <!-- Row A -->
            <tr>
              <td rowspan="2">№</td>
              <td rowspan="2">DESCRIPTION / ОПИСАНИЕ</td>
              <td rowspan="2" colspan="2">QTY / КОЛИЧЕСТВО</td>
              <td rowspan="2">PACK NO, TYPE / НОМЕР УПАКОВКИ И ТИП</td>
              <td colspan="2">UNIT WEIGHT / ЕДИНИЦА ИЗМЕРЕНИЯ</td>
              <!--<td>7</td> -->
              <td colspan="3" rowspan="2">DIMENSIONS / РАЗМЕРЫ</td>
            </tr>
            <!-- Row B -->
            <tr>
              <td>Net / Нетто вес (kg)</td>
              <td>Gross / Общий вес (kg)</td>
            </tr>
            <!-- Row C -->
            <tr v-for="(good, ind) in packing.goods" :key="ind">
              <td>{{ ind }}</td>
              <td>{{ good.goodsdescription }}</td>
              <td>{{ good.goodsquantity }}</td>
              <td>{{ good.measureunitqualifiername }}</td>
              <td>
                {{ good.goodsvolume }} {{ good.measureunitqualifiername }}
              </td>
              <td>{{ good.netweightquantity }}</td>
              <td>{{ good.grossweightquantity }}</td>
              <td colspan="3">{{ good.dimensions }}</td>
            </tr>
            <!-- Row D -->
            <tr>
              <td colspan="2">TOTAL NET WEIGHT / ОБЩАЯ МАССА НЕТТО (KG):</td>
              <td colspan="8">{{ packing.net_weight_quantity }}</td>
            </tr>
            <!-- Row E -->
            <tr>
              <td colspan="2">TOTAL GROSS WEIGHT / ОБЩИЙ ВЕС БРУТТО (KG):</td>
              <td colspan="8">{{ packing.gross_weight_quantity }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user_id", "doc_id"],
  data() {
    return {
      packings: [],
    };
  },
  mounted() {
    axios
      .get(window.base + "/document/getPackingList/?doc_id=" + this.doc_id)
      .then((response) => {
        this.packings = response.data.map((item, index) => {
          if (item.invoice && item.invoice.DocumentID) {
            item.invoice.value = item.invoice.DocumentID;
            item.invoice.display_text =
              this.$t(
                "message.contracts.documents_packaging_list_invoce_by_contract",
              ) +
              this.$route.params.id +
              "(" +
              item.invoice.DocumentNumber +
              ")";
          }
          if (item.consignor && item.consignor.org_name)
            item.consignor_name = item.consignor.org_name;
          if (item.consignee && item.consignee.org_name)
            item.consignee_name = item.consignee.org_name;

          if (item.transports) {
            item.transports.map((transp) => {
              if (
                transp.packaging_transportcountrycode &&
                transp.packaging_transportcountrycode.value
              )
                axios
                  .get(
                    window.base +
                      "/library/country/?code=" +
                      transp.packaging_transportcountrycode.value +
                      "&lang=" +
                      this.$i18n.locale,
                  )
                  .then((r) => {
                    transp.packaging_transportcountrycode = r.data[0];
                  });
              if (
                transp.packaging_transporttypecode &&
                transp.packaging_transporttypecode.value
              )
                axios
                  .get(
                    window.base +
                      "/library/transporttype/?code=" +
                      transp.packaging_transporttypecode.value +
                      "&lang=" +
                      this.$i18n.locale,
                  )
                  .then((r) => {
                    transp.packaging_transporttypecode = r.data[0];
                  });
              return transp;
            });
          }

          if (item.places) {
            item.places.map((pl) => {
              if (
                pl.packaging_packagingtypecode &&
                pl.packaging_packagingtypecode.value
              )
                axios
                  .get(
                    window.base +
                      "/library/packaging/?code=" +
                      pl.packaging_packagingtypecode.value +
                      "&lang=" +
                      this.$i18n.locale,
                  )
                  .then((r) => {
                    pl.packaging_packagingtypecode = r.data[0];
                  });
              return pl;
            });
          }

          if (index == response.data.length - 1) {
            setTimeout(() => {
              this.$root.$emit("print-pdf", {
                signature: "",
                type: "packaging",
              });
            }, 300);
          }
          return item;
        });
      });
  },
  methods: {},
};
</script>
